<template>
    <div ref="customFieldCheck">
        <b-row>
            <b-col cols="12">
                <hr />
            </b-col>
            <b-col md="12">
                <h6>Custom Fields</h6>
            </b-col>
        </b-row>
        <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <div :style="{ height: trHeight }" class="repeater-form">
            <b-row v-for="(item, index) in AdditionalFields" :id="item.ordering" :key="item.ordering"
                ref="additionalFields">
                <b-col md="4">
                    <b-form-group label="Field Name" label-for="fieldname">
                        <validation-provider rules="required" #default="{ errors }" name="Field Name">
                            <b-form-input id="fieldname" type="text" placeholder="Field Name" required
                                v-model="item.fieldName" />
                            <small v-if="errors.length" class="text-danger text-end">{{
                                errors[0]
                                }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Remove Button -->
                <b-col lg="3" md="4" class="mb-50">
                    <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="mt-0 mt-md-2"
                        @click="removeItem(index)">
                        <feather-icon icon="XIcon" class="mr-25" />
                        <span>Delete</span>
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="justify-between-end">
                <b-col cols="3">
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="repeateAgain">
                        <feather-icon icon="PlusIcon" class="mr-25" />
                        <span>Add New</span>
                    </b-button>
                </b-col>
                <b-col cols="3">
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="handleSubmit(upsertCustomFields)">
                        <span>Save</span>
                    </b-button>
                </b-col>
            </b-row>
        </div>
        </ValidationObserver>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormTextarea,
    BFormSelect,
    BFormFile,
    BCardText,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { heightTransition } from '@core/mixins/ui/transition';
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex/";
import customFields from "@/store/customFields";
import { customLoader, customError, customSwal } from '@/libs/customFn';

export default {
    components: {
        // validation rules
        required,
        BRow,
        BFormSelect,
        BCol,
        ToastificationContent,
        BFormFile,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BForm,
        BFormTextarea,
        BButton,
        BCardText,
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        Ripple,
    },
    props: {
        ModuleReference: {
            type: String
        },
    },
    data() {
        return {
            defaultField: [
                {
                    ordering: 0,
                    fieldName: null,
                    fieldType: "text",
                    isRequired: false,
                    displayEcomm: false,
                }
            ],
            AdditionalFields: [
                {
                    ordering: 0,
                    fieldName: null,
                    fieldType: "text",
                    isRequired: false,
                    displayEcomm: false,
                }
            ],
            Sections: [],
            nextOrdering: 1,
        }
    },
    mixins: [heightTransition],
    methods: {
        ...mapActions("customFieldsModule", ["getCustomFieldsListAction", "deleteCustomFieldsAction", "upsertCustomFieldsAction"]),
        repeateAgain() {
            this.nextOrdering = this.AdditionalFields.length;
            this.AdditionalFields.push({
                ordering: this.nextOrdering,
            });

            this.$nextTick(() => {
                this.trAddHeight(this.$refs.additionalFields[0].offsetHeight);
            });
        },
        async removeItem(index) {
            let fieldId = this.AdditionalFields[index].id;
            if (fieldId != undefined && fieldId != null) {
                await this.deleteCustomFieldsAction({ section: this.ModuleReference, payload: fieldId }).then((result) => {
                    if (result.success) {
                        customSwal(result.message, 'Success', 'success');
                        this.getCustomFieldsListAction({ section: this.ModuleReference, payload: this.ModuleReference });
                    } else {
                        customError(result, 'Error');
                    }
                });
            }
            this.AdditionalFields.splice(index, 1);
            this.trTrimHeight(this.$refs.additionalFields[0].offsetHeight);
        },
        initTrHeight() {
            this.trSetHeight(null);
            this.$nextTick(() => {
                this.trSetHeight(this.$refs.additionalFields.scrollHeight);
            })
        },
        async fieldsValidation() {
            let isValid = await this.$refs.customFieldCheck.validate();
            return isValid;
        },
        async upsertCustomFields() {
            let payload = {
                "section": this.ModuleReference,
                "customFields": this.AdditionalFields
            };
            await this.upsertCustomFieldsAction({ section: this.ModuleReference, payload: payload }).then((result) => {
                if (result.customFields.length > 0) {
                    const successMessage = `Custom fields added successfully for ${this.ModuleReference}`;
                    customSwal(successMessage, 'Success', 'success');
                    this.AdditionalFields = result.customFields;
                } else {
                    customError(result, 'Error');
                }
            });
        },
    },
    computed: {
        ...mapGetters("customFieldsModule", {
            customFields: "customFields",
            loading: "loading"
        }),
    },
    async mounted() {
        this.initTrHeight();
        await this.getCustomFieldsListAction({ section: this.ModuleReference, payload: this.ModuleReference });
        this.AdditionalFields = this.customFields(this.ModuleReference);
        if(this.AdditionalFields == undefined) this.AdditionalFields = this.defaultField;
    },
    created() {
        window.addEventListener('resize', this.initTrHeight)
    },
    destroyed() {
        window.removeEventListener('resize', this.initTrHeight)
    }
}
</script>